module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listAddressMsg.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_address_3x.png",
      "emptytext": "您还没有添加收货地址",
      "btntext": "去添加",
      "btnurl": "/main/writeaddress"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listAddressMsg.length != 0 && !_vm.loadShow) ? _c('div', {
    staticClass: "flex-column address-list"
  }, [_c('div', {
    staticClass: "flex-item"
  }, _vm._l((_vm.listAddressMsg), function(listAddressShow, addressIndex) {
    return _c('div', {
      staticClass: "address-item"
    }, [_c('p', {
      staticClass: "address"
    }, [_vm._v(_vm._s(listAddressShow.province) + "  " + _vm._s(listAddressShow.city) + "  " + _vm._s(listAddressShow.area) + "  " + _vm._s(listAddressShow.address))]), _vm._v(" "), _c('p', {
      staticClass: "user"
    }, [_c('label', [_vm._v(_vm._s(listAddressShow.consignee))]), _vm._v(" "), _c('label', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(listAddressShow.mobile))])]), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, [_c('mu-radio', {
      staticClass: "list-radio",
      class: [listAddressShow.isDefault == 1 ? 'primary' : ''],
      attrs: {
        "name": "group",
        "label": listAddressShow.isDefault == 1 ? '默认地址' : '设为默认',
        "nativeValue": listAddressShow.addressId
      },
      on: {
        "change": function($event) {
          return _vm.changeCheck(listAddressShow.addressId, listAddressShow.isDefault)
        }
      },
      model: {
        value: (_vm.defaultAddress),
        callback: function($$v) {
          _vm.defaultAddress = $$v
        },
        expression: "defaultAddress"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "edit-address fr",
      on: {
        "click": function($event) {
          return _vm.editAddress(listAddressShow.addressId, listAddressShow.memId)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('p', {
      staticClass: "delete-address fr",
      on: {
        "click": function($event) {
          return _vm.deleteAddress(listAddressShow.addressId)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "添加新地址",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.addAddress()
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDelete,
      "title": "删除地址",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.isDelete = false
      }
    }
  }, [_vm._v("\n    确定删除这个地址？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.isDelete = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": function($event) {
        return _vm.closedeleteAddress()
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast1) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "设置成功!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toast2) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "删除成功!"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-527050d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/myaddress.vue
// module id = 402
// module chunks = 68